import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const generateFollowupQuestions = createAsyncThunk(
  "generateFollowupQuestions",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/dynamic-followup-question/generate`,
        payload
      );
      if (data.success) return { questionId: payload.questionId, items: data.data || [] };
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const getFollowupQuestions = createAsyncThunk(
  "getFollowupQuestions",
  async ({ interviewId, userId, questionId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/dynamic-followup-question/get`,
        { interviewId, userId, questionId }
      );
      if (data.success) return { questionId, items: data.data || [] };
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const answerFollowupQuestion = createAsyncThunk(
  "answerFollowupQuestion",
  async ({ followupId, candidateAnswer, questionId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/dynamic-followup-question/answer`,
        { followupId, candidateAnswer }
      );
      if (data.success) return { questionId, items: data.data || [] };
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export {
  generateFollowupQuestions,
  getFollowupQuestions,
  answerFollowupQuestion,
};
